import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";

const notificationSelector = (state: RootState) => state.notification;

const listNotificationSelector = createSelector(
  notificationSelector,
  (state) => state.getListNotification
);

export const getListNotificationDataSelector = createSelector(
  listNotificationSelector,
  (state) => state.data
);

export const getTotalNotificationDataSelector = createSelector(
  listNotificationSelector,
  (state) => state.totalRecords
);

export const getListNotificationStatusSelector = createSelector(
  listNotificationSelector,
  (state) => state.status
);
